import type { ConfigField } from '@chukua/common';
import { Form, Input, InputNumber, Switch } from 'antd';

interface ConfigFieldsProps {
  fields: ConfigField[];
  /** Names of secrets that already hold a value: their input says "Saved" and may be left blank. */
  secretsSet: string[];
}

/** One form item per field of the adapter's config schema, so a new vendor needs no new screen. A secret is a password input that is never prefilled. */
export function ConfigFields({ fields, secretsSet }: ConfigFieldsProps) {
  return (
    <>
      {fields.map((field) => {
        const isSaved = field.secret && secretsSet.includes(field.name);
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={field.label}
            extra={field.help}
            valuePropName={field.type === 'boolean' ? 'checked' : 'value'}
            rules={[{ required: field.required && !isSaved, message: `Enter ${field.label.toLowerCase()}` }]}
          >
            {renderInput(field, isSaved)}
          </Form.Item>
        );
      })}
    </>
  );
}

function renderInput(field: ConfigField, isSaved: boolean) {
  if (field.type === 'boolean') return <Switch />;
  if (field.type === 'number') return <InputNumber className="w-full" />;
  if (field.secret) return <Input.Password autoComplete="new-password" placeholder={isSaved ? 'Saved — leave blank to keep it' : undefined} />;
  return <Input />;
}
